import { render, staticRenderFns } from "./regularizacion_inventario - copia.vue?vue&type=template&id=4c27f044&"
import script from "./regularizacion_inventario - copia.vue?vue&type=script&lang=js&"
export * from "./regularizacion_inventario - copia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports